let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("cM9em"), load("fr9NE"), load("8I8t1")]).then(() => parcelRequire('lpMzx'));